// MEGA MENU
export function megaMenu($) {
    var menuTimeout;
    var time = 200;

    $(".main-navbar .nav-link")
        .on("mouseenter", function () {
            var data = $(this).data("menu");
            var menu = "#" + data;

            $(".mega-menu-container").attr("data-active", "false");
            $(".main-navbar .nav-link").removeClass("active");
            $(".mega-menu-container").removeClass("active");

            clearTimeout(menuTimeout);

            $(this).addClass("active");
            $(menu).addClass("active").attr("data-active", "true");
        })
        .on("mouseleave", function () {
            var data = $(this).data("menu");
            var menu = "#" + data;

            menuTimeout = setTimeout(function () {
                $(this).removeClass("active");
                $(menu).removeClass("active").attr("data-active", "false");
                $(".main-navbar .nav-link").removeClass("active");
            }, time);
        });

    $(".mega-menu-container")
        .on("mouseenter", function () {
            clearTimeout(menuTimeout);
        })
        .on("mouseleave", function () {
            var data = $(this).attr("id");
            var menu = $("#" + data);
            var active = $(this).attr("data-active");

            if (active == "true") {
                menuTimeout = setTimeout(function () {
                    menu.removeClass("active").attr("data-active", "false");
                    $(".main-navbar .nav-link").removeClass("active");
                }, time);
            }
        });

    $(".main-navbar")
        .on("mouseover", function () {
            clearTimeout(menuTimeout);
        }).on("mouseleave", function () {
            menuTimeout = setTimeout(function () {
                $(".mega-menu-container").removeClass("active").attr("data-active", "false");
                $(".main-navbar .nav-link").removeClass("active");
            }, time);
        });
}

// STICKY MENU
export function stickyMenu($) {
    var frontPage = document.getElementsByClassName('front-page');

    if (frontPage) {
        $(window).on('scroll', function () {
            var height = $('.homepage-slider').height();
            // var height = 500;

            if ($(this).scrollTop() > height) {
                $('.theme-header').addClass('sticky');
            } else {
                $('.theme-header').removeClass('sticky');
            }
        });
    }
}

// Burger Menu
export function toggleMenu($) {
    $('#mainNavigationToggleMenu').on('click', function () {
        var data = $(this).data('open');
        var mobile = $('#mainnavigationtogglemobile');

        if ($('.root-business').length > 0) {
            mobile = $('#mainnavigationtogglebusinessmobile');
        }

        $(this).attr('aria-expanded', ($(this).attr('aria-expanded') == 'false' ? 'true' : 'false'));

        $(this).toggleClass("active");

        if ($(window).width() <= 1115) {
            mobile.toggleClass("active");
        }
        else {
            $(data).toggleClass("active");
        }
    })
}

export function mobileMenu($) {
    $(".mobile-menu li").click(function (e) {
        // Prevent event from bubbling up to parent items
        e.stopPropagation();

        // If the clicked item has children (submenu), toggle it
        var submenu = $(this).children("ul");

        if (submenu.length > 0) {
            // Slide toggle the clicked submenu
            submenu.animate(
                {
                    height: "toggle",
                    opacity: "toggle",
                },
                300
            );

            // Toggle the active class on the clicked item
            $(this).toggleClass("active");

            // Close other submenus on the same level
            // $(this).siblings('li').removeClass('active').children('ul').slideUp();
        }
    });
}

export function rootMenu($) {
    var root = $(".root-menu").data("root");

    if (root == "/home") {
        root = "/";
    }

    if (root) {
        $('.top-nav .nav-link[href="' + root + '"]').addClass("is-active");
    }
}

//business
export function businessLogoLink($) {
    var root = $('.root-business');

    if (root.length > 0) {
        $('header .navbar-brand').prop('href', '/business');
        $('header .navbar-brand img').prop('src', '/sites/default/files/business/logo/ewb-business-logo.png');
        $('.btn-burger .hz-line').css('background-color', '#fff');
        $('.personal-footer-link').css('display', 'none');
        $('.personal-footer-link').parent().css('display', 'none');
    } else {
      $('.business-footer-link').css('display', 'none');
      $('.business-footer-link').parent().css('display', 'none');
    }
}
